<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">Process Purchase Order #{{ po_id }}</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <h2>Loading...</h2>
      </div>
      <div v-if="!loading" class="modal-body">
        <div class="form-group">
          <label for="store">Select Store to move items to:</label>
          <select v-model="selectedStore" id="store" class="form-control">
            <option disabled value="">-- Choose Store --</option>
            <option v-for="store in stores" :key="store.id" :value="store.id">
              {{ store.store_name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="processingDate">Processing Date:</label>
          <input
            type="date"
            v-model="processingDate"
            id="processingDate"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="remarks">Remarks (optional):</label>
          <textarea
            v-model="remarks"
            id="remarks"
            rows="3"
            class="form-control"
          ></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!selectedStore || !processingDate"
          @click="processPO"
        >
          Process PO
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "POProcessingModal",
  props: {
    po_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      stores: [], // Replace this with your API call result
      selectedStore: "",
      processingDate: new Date().toISOString().substr(0, 10),
      remarks: "",
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-process-modal");
    },
    async processPO() {
      this.loading = true;
      const payload = {
        po_id: this.po_id,
        store_id: this.selectedStore,
        processing_date: this.processingDate,
        remarks: this.remarks,
      };
      await generalApiRequest(`inventory/accept_po_items`, "POST", payload, 1);
      this.loading = false;
      this.closeModal();
    },
    async fetchStores() {
      const res = await generalApiRequest(
        `inventory/getCompanyItemStores_for_input`,
        "GET",
        {},
        1
      );
      this.stores = res.data;
    },
  },
  mounted() {
    this.fetchStores();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem 1rem;
}

.close {
  background: #e31616;
  border: 1px solid #b6b2b2;
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.4rem;
  font-size: 1rem;
}
</style>
